export default __webpack_public_path__ + "static/media/Home_avg.391adf84.jpeg";